import React from "react";
import { RealTimeManager } from "../system/RealTimeManager";

export const SocketContext = React.createContext<RealTimeManager>(
  null as unknown as RealTimeManager
);

export const SocketProvider = SocketContext.Provider;
